import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateCreateCompanyROute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useCreateCompanyProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateCompany = ({
    setErrorText = () => { },
}: useCreateCompanyProps) => {
    const client = useQueryClient();

    const { mutate: createCompany, isLoading: isCreatingCompany } =
        useMutation({
            mutationFn: (variables:
                {
                    etemplate_id: number | string
                    business_name: string
                    email: string
                    manual: false
                    phone: number
                    s_address1: string
                    s_city: string
                    s_lat: string
                    s_lon: string
                    s_state: string
                    s_website_url: string
                    s_zip: string
                    timezone: string
                    user_name: string
                }) =>
                axiosInstance
                    .post(templateCreateCompanyROute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([templateList]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        createCompany,
        isCreatingCompany,
    };
};
